
import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

const getPanelMapping = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.getPanelMapping}`,
    queryModel
  );
};
const createOrUpdatePanelMapping = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.createOrUpdatePanelMapping}`,
    queryModel
  );
};

const AssayDataLookup = () => {
  return HttpClient().get(`/${apiRoutes.OncologyCompendium.AssayDataLookup}`);
};

const GroupLookup = () => {
  return HttpClient().get(`/${apiRoutes.OncologyCompendium.GroupLookup}`);
};
const PerformingLabLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.OncologyCompendium.PerformingLabLookup}`
  );
};

const deletePanelMapping = (id: number) => {
  return HttpClient().delete(
    `/${apiRoutes.OncologyCompendium.DeletedPanelMapping}?Id=${id}`
  );
};
const restoreDeletedPanelMapping = (id: number) => {
  return HttpClient().delete(
    `/${apiRoutes.OncologyCompendium.RestoreDeletePanelMapping}?Id=${id}`
  );
};

// const panelMappingExportToExcel = (queryModel) => {
//   return HttpClient().post(
//     `/${apiRoutes.InfectiousDisease.panelMappingExportToExcel}`,
//     queryModel
//   );
// };
const OncologyPanelMappingService = {
  getPanelMapping,
  createOrUpdatePanelMapping,
  AssayDataLookup,
  GroupLookup,
  PerformingLabLookup,
  deletePanelMapping,
  restoreDeletedPanelMapping,
};

export default OncologyPanelMappingService;
